import nprogress from 'nprogress';
import { ActionTypes } from 'actionsConstants';
import { hitApi, ObservableAjax } from '__common/utils/api';
import {
  SET_LOADER_MSG,
  LOAD_OS_PROJECT_CONFIGURATION,
  REDIRECT_TO_OS_PROJECT,
  IMPORT_OS_PROJECT_SUCCESS,
  USER_LOGIN_SUCCESS,
} from 'actions';
import { dispatch } from '__common/store';
import { safeOfType as ofType } from '__common/utils/safeOfType';
import { switchMap, withLatestFrom } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { AnyAction } from 'redux';


export function osDesignConfigInitDataRequest(action$: Observable<any>) {
  return action$.pipe(
    ofType(ActionTypes.OS_DESIGN_CONFIG_INIT_DATA_REQUEST),
    switchMap((action: any) => {

      const authToken = action.payload.payload?.authToken;

      if (authToken) {
        dispatch(
          USER_LOGIN_SUCCESS(
            authToken,
            'open-solar',
            'opensolar@testing.com',
            false,
            false,
            [],
            []
          )
        );
      }

      return ObservableAjax({
        until$: action$.pipe(ofType(ActionTypes.OS_DESIGN_CONFIG_INIT_DATA_SUCCESS)),
        onSuccess: LOAD_OS_PROJECT_CONFIGURATION,
        onErrorMessage: 'Cannot fetch project data',
        socketName: 'project',
        onSocketPending: 'Wait Syncing Open Solar with U-builder.....',
        onSocketStart: 'Importing Open Solar Design into U-builder',
        onSocketFailure: 'Open Solar Import Failure......',
        onErrorAction: () => nprogress.done(),
        link: hitApi('post', `api/v1/opensolar/`, action.payload.payload),
      });
    })
  );
}


export function importOsFullDesignProject(action$: Observable<any>) {
  return action$.pipe(
    ofType(ActionTypes.IMPORT_OS_FULL_DESIGN_PROJECT),
    switchMap((action: any) => {

      dispatch(SET_LOADER_MSG('Importing Open Solar Full Design Project'));

      const authToken = action.payload.data?.authToken;

      if (authToken) {
        dispatch(
          USER_LOGIN_SUCCESS(
            authToken,
            'open-solar',
            'opensolar@testing.com',
            false,
            false,
            [],
            []
          )
        );
      }

      return ObservableAjax({
        onSuccess: IMPORT_OS_PROJECT_SUCCESS,
        onErrorMessage: 'Cannot import project',
        socketName: 'project',
        onSocketFailure: 'OS FULL DESIGN IMPORT FAILURE',
        showBackendErrorMsgOnFailure: true,
        onErrorAction: () => nprogress.done(),
        link: hitApi('post', 'api/v1/opensolar_full_design_import/', action.payload.data),
      });
    })
  );
}


export function redirectOsLandingPageAfterProjectConfig(
  action$: Observable<AnyAction>,
  state$: Observable<appState>,
): Observable<AnyAction> {
  return action$.pipe(
    ofType(ActionTypes.REDIRECT_OS_PAGE),
    withLatestFrom(state$),
    switchMap(([, appState]) => {
      const os_project_id = appState.projectConfiguration?.projectEnvConfig?.os_project_id;
      return of(REDIRECT_TO_OS_PROJECT(os_project_id));
    }),
  );
}
